const THEME_STORAGE_KEY = 'ivs-board-theme';
const LIGHT_THEME_COLOR = '#f4f7fb';
const DARK_THEME_COLOR = '#08111f';

function safeReadTheme(storage) {
  try {
    const value = storage?.getItem?.(THEME_STORAGE_KEY);
    return value === 'dark' || value === 'light' ? value : null;
  } catch {
    return null;
  }
}

function safeWriteTheme(storage, theme) {
  try {
    storage?.setItem?.(THEME_STORAGE_KEY, theme);
  } catch {}
}

export function initTheme({
  button,
  root = document.documentElement,
  meta = document.querySelector('meta[name="theme-color"]'),
  storage = window.localStorage,
  mediaQuery = window.matchMedia?.('(prefers-color-scheme: dark)')
} = {}) {
  if (!button || !root) return null;

  const applyTheme = (theme, { persist = false } = {}) => {
    const next = theme === 'dark' ? 'dark' : 'light';
    const isDark = next === 'dark';

    root.dataset.theme = next;
    button.setAttribute('aria-pressed', String(isDark));
    button.setAttribute(
      'aria-label',
      isDark ? 'Chuyển sang giao diện sáng' : 'Chuyển sang giao diện tối'
    );
    button.title = isDark ? 'Chuyển sang giao diện sáng' : 'Chuyển sang giao diện tối';

    meta?.setAttribute('content', isDark ? DARK_THEME_COLOR : LIGHT_THEME_COLOR);
    if (persist) safeWriteTheme(storage, next);
    return next;
  };

  const storedTheme = safeReadTheme(storage);
  applyTheme(storedTheme || (mediaQuery?.matches ? 'dark' : 'light'));

  button.addEventListener('click', () => {
    const next = root.dataset.theme === 'dark' ? 'light' : 'dark';
    applyTheme(next, { persist: true });
  });

  mediaQuery?.addEventListener?.('change', event => {
    if (!safeReadTheme(storage)) applyTheme(event.matches ? 'dark' : 'light');
  });

  return { applyTheme };
}
